import { render, staticRenderFns } from "./LatestNews.vue?vue&type=template&id=6978ace8"
import script from "./LatestNews.js?vue&type=script&lang=js&external"
export * from "./LatestNews.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports